import React from 'react';
import { ButtonBase, makeStyles, Typography } from '@material-ui/core';
import RatingStatusIcon from './RatingStatusIcon';

export interface IRatingRailItem {
  key: string;
  title: string;
  subtitle: string;
  chips: string[];
  filled: number;
  total: number;
}

const useStyles = makeStyles({
  root: { borderRight: '1px solid #e6e9ee', backgroundColor: '#fafbfd', overflowY: 'auto', minHeight: 0 },
  head: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    display: 'flex',
    gap: 10,
    padding: '9px 16px',
    borderBottom: '1px solid #e6e9ee',
    backgroundColor: '#fff',
    fontSize: 10,
    letterSpacing: '.06em',
    textTransform: 'uppercase',
    color: '#8a93a0',
  },
  row: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    padding: '11px 16px',
    borderBottom: '1px solid #eef1f5',
    textAlign: 'left',
    '&:hover': { backgroundColor: '#f1f5fb' },
  },
  status: { width: 18, flexShrink: 0 },
  name: { flex: 1, minWidth: 0 },
  title: { fontSize: 13, color: '#374151' },
  titleActive: { fontSize: 13, fontWeight: 700, color: '#0b3f9e' },
  subtitle: { fontSize: 11, color: '#9ca3af' },
  chips: { width: 196, flexShrink: 0, display: 'flex', flexWrap: 'wrap', gap: 4 },
  chip: {
    fontSize: 10,
    color: '#4b5563',
    backgroundColor: '#eaeef4',
    padding: '2px 6px',
    borderRadius: 4,
    whiteSpace: 'nowrap',
  },
  counter: { width: 26, flexShrink: 0, textAlign: 'right', fontSize: 11, color: '#9ca3af' },
});

interface IProps {
  items: IRatingRailItem[];
  activeIndex: number;
  onSelect(index: number): void;
}

const RatingRail = ({ items, activeIndex, onSelect }: IProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.head}>
        <span className={classes.status} />
        <span className={classes.name}>Партнер</span>
        <span className={classes.chips}>Обслуживает ЖК</span>
        <span className={classes.counter}>Оц.</span>
      </div>

      {items.map((item, index) => (
        <ButtonBase key={item.key} component="div" className={classes.row} onClick={() => onSelect(index)}>
          <RatingStatusIcon filled={item.filled} total={item.total} />
          <div className={classes.name}>
            <Typography noWrap className={index === activeIndex ? classes.titleActive : classes.title}>
              {item.title}
            </Typography>
            <Typography className={classes.subtitle}>{item.subtitle}</Typography>
          </div>
          <div className={classes.chips}>
            {item.chips.map((chip) => (
              <span key={chip} className={classes.chip}>
                {chip}
              </span>
            ))}
          </div>
          <span className={classes.counter}>
            {item.filled}/{item.total}
          </span>
        </ButtonBase>
      ))}
    </div>
  );
};

export default RatingRail;
